import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { ModalClose } from 'builder/components/ModalClose'
import Icon from 'builder/components/Icon'
import Button, { ButtonTheme } from 'builder/components/Button'

export const Modal = styled.div`
  display: flex;
  position: relative;
  touch-action: none;

  ${Media.Phone` margin: 16px; `}
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacing.L} ${Spacing.L} 0 ${Spacing.L};
  overflow-y: scroll;
  max-height: 570px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Colors.Neutral50};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${Colors.Neutral10};
  }

  scrollbar-width: thin;
  scrollbar-color: ${Colors.Neutral50} ${Colors.Neutral10};

  ${Media.Phone` padding: ${Spacing.L} ${Spacing.M} 0 ${Spacing.M}; `}
`

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${Spacing.L};
  margin-bottom: ${Spacing.M};

  ${Media.Phone` padding-bottom: ${Spacing.M}; `}
`

export const Container = styled.div`
  display: flex;
  background-color: ${Colors.White};
  border-radius: ${Spacing.S};
  max-width: 544px;
  width: 100%;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  justify-content: center;
  touch-action: manipulation;
`

export const Title = styled.div`
  ${Typography.M};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const CloseButton = styled(ModalClose)`
  position: absolute;
  top: 32px;
  right: 32px;

  ${Media.Phone`
    top: 20px;
    right: 20px;
  `}
`

export const ItemsTitle = styled.span`
  ${Typography.Body};
  color: ${Colors.Neutral90};
  margin-top: ${Spacing.M};
`

export const ItemContainer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
  margin-top: ${Spacing.XS};

  background-color: ${Colors.Neutral5};
  border-radius: ${Spacing.XS};
  padding: ${Spacing.S} ${Spacing.XL} ${Spacing.S} ${Spacing.S};
`

export const TickContainer = styled.div`
  border-radius: 100%;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.Blue10};
  padding: 4px;

  ${Media.Phone`
    width: 24px;
    height: 24px;
  `}
`

export const Tick = styled(Icon.TickLarge)`
  color: ${Colors.Blue50};

  ${Media.Phone`
    width: 16px;
    height: 16px;
  `}
`

export const ItemDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['4XS']};
`

export const ItemTitle = styled.span`
  ${Typography.Body};
  color: ${Colors.Neutral80};
  ${FontWeights.DemiBold};
`

export const ItemDescription = styled.p`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
`

export const Footer = styled.div`
  padding: ${Spacing.M};
  display: flex;
  gap: ${Spacing.S};
  box-shadow: 0px 2px 4px -1px rgba(15, 20, 30, 0.16), 0px 8px 20px -4px rgba(15, 20, 30, 0.24);
  justify-content: flex-end;
  align-items: center;

  ${Media.Phone`
    flex-direction: column-reverse;
    gap: 10px;
  `}
`

export const CTA = styled(Button)`
  ${({ theme }) =>
    theme === ButtonTheme.ghost &&
    css`
      background: none;
      color: ${Colors.Blue50};
      padding: 0;
      border: none;
      box-shadow: none;
      text-decoration: none;
      font-weight: ${FontWeights.Medium};

      &:hover,
      &:focus-visible {
        text-decoration: underline;
        color: ${Colors.Blue60};
        box-shadow: none;
      }

      &:active {
        color: ${Colors.Blue70};
        box-shadow: none;
      }
    `}
`
